import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

import OkC from "shared/util/OkcApi";
import { setInitialState as setEditDetailsState } from "./edit_details";
import { setInitialState as setProfileEditState } from "./profile_edit";

// actions
// -----------------------------------------------------------------------------

export const SET_INITIAL_STATE = "EDIT_WIW.SET_INITIAL_STATE";
export const SHOW_MODAL = "EDIT_WIW.SHOW_MODAL";
export const HIDE_MODAL = "EDIT_WIW.HIDE_MODAL";
export const UPDATE_SENTENCE = "EDIT_WIW.UPDATE_SENTENCE ";
import { SAVE_FIELD_DATA_SUCCESS } from "./what_i_want";


// initial state
// -----------------------------------------------------------------------------

const INITIAL_STATE = {
	isUpdatingSentence: false,
	sentence: "",
};

const getInitialState = () => {
	const windowParams = get(window, "__PROFILE_EDIT_PARAMS__.wiw.data", {});

	if (windowParams.sentence && windowParams.sentence.sentence) {
		windowParams.sentence = windowParams.sentence.sentence;
	}

	return {
		...INITIAL_STATE,

		...windowParams,
		hasLoadedProfileEditData: !isEmpty(windowParams),
	};
};


// reducer
// -----------------------------------------------------------------------------

export const reducer = (state = getInitialState(), action) => {
	switch (action.type) {
		case SET_INITIAL_STATE: {
			const data = get(action.payload, "wiw", {});

			if (data.sentence && data.sentence.sentence) {
				data.sentence = data.sentence.sentence;
			}

			return {
				...state,
				...data,
				hasLoadedProfileEditData: true,
			};
		}

		case UPDATE_SENTENCE: {
			return {
				...state,
				sentence: action.payload.sentence,
				isUpdatingSentence: false,
			};
		}

		// this action hooks into the What I Want app's success action to get the
		// updated What I Want sentence.
		case SAVE_FIELD_DATA_SUCCESS: {
			let sentence = state.sentence;

			if (
				action.res && action.res.wiw && action.res.wiw.sentence &&
				action.res.wiw.sentence.sentence
			) {
				sentence = action.res.wiw.sentence.sentence;
			}

			return {
				...state,
				sentence,
			};
		}

		default: {
			return state;
		}
	}
};


// action exporters
// -----------------------------------------------------------------------------

export const setInitialState = (payload) => {
	return {
		type: SET_INITIAL_STATE,
		payload,
	};
};

export const loadProfileEditData = () => {
	return (dispatch) => {
		OkC.get("/profile/me/profile_edit_params")
			.then((data) => {
				dispatch(setProfileEditState(data));
				dispatch(setEditDetailsState(data));
				dispatch(setInitialState(data));
			});
	};
};

export const updateSentence = (sentence) => {
	return {
		type: UPDATE_SENTENCE,
		payload: { sentence },
	};
};



// WEBPACK FOOTER //
// ./src/ducks/edit_wiw.js